/** Admin route helpers the app shell imports statically.
 *
 *  Kept tiny on purpose (no MUI, no icons): the shell decides between
 *  the session list and the admin navigation on every render, and the
 *  admin navigation itself is lazy-loaded so members never download it. */

export const ADMIN_ROOT = "/app/admin";

/** ``/app/admin`` and everything below it — not ``/app/administrator``. */
export function isAdminPath(pathname: string): boolean {
  return pathname === ADMIN_ROOT || pathname.startsWith(`${ADMIN_ROOT}/`);
}

const SESSIONS_ROOT = "/app/sessions";
const LAST_SESSIONS_KEY = "rw.admin.lastSessionsPath";
/** A sessions page: ``/app/sessions`` itself or anything below it. */
const SESSIONS_PATH = /^\/app\/sessions(?:[/?#]|$)/;

/** Remember the session page the viewer was on, so "Back to sessions"
 *  in the admin menu returns to it rather than to an empty sessions
 *  page. Per browser tab (sessionStorage): two tabs keep their own. */
export function rememberSessionsPath(pathname: string, search: string): void {
  if (pathname !== SESSIONS_ROOT && !pathname.startsWith(`${SESSIONS_ROOT}/`)) return;
  try {
    sessionStorage.setItem(LAST_SESSIONS_KEY, `${pathname}${search}`);
  } catch {
    /* private mode / blocked storage: the fallback is the sessions page */
  }
}

/** Where "Back to sessions" goes. The stored value is checked, not
 *  trusted: anything that isn't a sessions path falls back. */
export function lastSessionsPath(): string {
  try {
    const stored = sessionStorage.getItem(LAST_SESSIONS_KEY);
    if (stored && SESSIONS_PATH.test(stored)) return stored;
  } catch {
    /* ignore */
  }
  return SESSIONS_ROOT;
}
